<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    :class="{ group: true, outlined }"
    :style="styles"
  >
    <div v-if="hasHeaderSlot">
      <slot name="header" />
    </div>
    <span
      v-else-if="name"
      class="group--label"
    >{{ name }}</span>
    <div :class="['group--content', `group--${currentDirection}`]">
      <slot />
    </div>
  </div>
</template>

<script>
import IoMediaQueryMixin from '../shared/mixins/IoMediaQueryMixin';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Group',
  mixins: [
    IoMediaQueryMixin,
  ],
  props: {
    name: {
      type: String,
      default: '',
    },
    breakpoint: {
      type: [Number, String],
      default: 0,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'row',
      validator: (val) => ['row', 'column'].includes(val),
    },
    layout: {
      type: String,
      default: '',
    },
    gap: {
      type: String,
      default: '1rem',
    },
    horizontalAlign: {
      type: String,
      default: 'flex-start',
      validator: (val) => ['unset', 'left', 'center', 'right', 'flex-start', 'flex-end', 'stretch'].includes(val),
    },
    verticalAlign: {
      type: String,
      default: 'flex-start',
      validator: (val) => ['unset', 'top', 'center', 'bottom', 'flex-start', 'flex-end'].includes(val),
    },
    filled: {
      type: String,
      default: '#fff',
    },
  },
  computed: {
    styles() {
      return {
        '--display': this.currentLayout ? 'grid' : 'flex',
        '--flex-direction': this.currentDirection,
        '--justify-content': this.currentDirection === 'column' ? this.verticalAlign : this.horizontalAlign,
        '--align-items': this.currentDirection === 'column' ? this.horizontalAlign : this.verticalAlign,
        '--gap': this.gap,
        '--group-filled': this.filled.includes('#')
          ? this.filled
          : `var(--${this.filled})`,
      };
    },
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    mediaBreakpoint() {
      return Number(this.breakpoint);
    },
    currentDirection() {
      return this.mediaQuery.default?.match ? 'column' : this.direction;
    },
    currentLayout() {
      return this.mediaQuery.default?.match ? '' : this.layout;
    },
  },
  mounted() {
    if (this.mediaBreakpoint) {
      // eslint-disable-next-line no-underscore-dangle
      this._media(this.mediaBreakpoint, true);
    }
  },
};
</script>

<style lang="scss" scoped>
.group {
    border-radius: 5px;
    position: relative;
    width: 100%;

    &--label {
        display: block;
        left: .25rem;
        padding: .5rem 0;
        font-size: 1rem;
        font-weight: 700;
        line-height: 1;
        background-color: var(--group-filled);
    }

    &--label + &--content {
        margin-top: calc(var(--gap) / 2);
    }

    &--content {
        display: var(--display);
        grid-template-columns: v-bind(currentLayout);
        flex-direction: var(--flex-direction);
        justify-content: var(--justify-content);
        align-items: var(--align-items);
        flex-wrap: wrap;
        gap: var(--gap);

        @media screen and (max-width: 960px) {
            > *:not(.base-button) {
                margin-right: 0 !important;
                width: 100% !important;
            }
        }
    }

    &.outlined {
        border: 1px solid #dee2e6;
        padding: .5rem;

        .group--label {
            position: absolute;
            top: -10px;
            padding: 0 .25rem;
        }
    }
}
</style>
